import lodashGet from 'lodash/get'
import { resolveBrowserLocale } from 'react-admin'

import englishMessages from './locales/en'
import spanishMessages from './locales/es'

const setLocale = () => {
  let locale = localStorage.getItem('locale')

  if (!locale) {
    locale = resolveBrowserLocale().indexOf('es') >= 0 ? 'es' : 'en'
  }

  return locale
}
let locale = setLocale()

const messages = {
  es: spanishMessages,
  en: englishMessages,
}
export default {
  translate: (key, options) => {
    let message = lodashGet(messages[locale], key)

    if (options?.params) {
      Object.keys(options.params).forEach((key) => {
        message = message.replace(`{${key}}`, options.params[key])
      })
    }

    return message
  },
  changeLocale: (newLocale) => {
    locale = newLocale
    localStorage.setItem('locale', locale)
    return Promise.resolve()
  },
  getLocale: () => locale,
}
